// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__3efJA","sendOtp":"AuthorizeToLogin_sendOtp__Ds6s4"};